import moment, { Moment } from "moment-timezone";
import { useTranslation } from "react-i18next";
import TabsComponent from "../tabs/TabsComponent";
import DateHeaderContainer from "./DateHeaderContainer";
import HoursGrid from "./HoursGrid";

type CandidateCalendarProps = {
  selectedDate: Moment | null;
  onSelectDate: (date: Moment | null) => void;
  selectedTime: Moment | null;
  onSelectTime: (time: Moment | null) => void;
  amHoursList: {
    dateTime: moment.Moment;
    isDisabled: boolean;
  }[];
  pmHoursList: {
    dateTime: moment.Moment;
    isDisabled: boolean;
  }[];
  dates: {
    date: moment.Moment;
    isDisabled: boolean;
  }[];
};

export default function CandidateCalendar(props: CandidateCalendarProps) {
  const {
    selectedDate,
    onSelectDate,
    selectedTime,
    onSelectTime,
    amHoursList,
    pmHoursList,
    dates,
  } = props;

  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.bookSession",
  });

  const timeTabs = [
    {
      name: t("am"),
      content: (
        <HoursGrid
          hoursList={amHoursList}
          onSelectTime={onSelectTime}
          selectedTime={selectedTime}
        />
      ),
    },
    {
      name: t("pm"),
      content: (
        <HoursGrid
          hoursList={pmHoursList}
          onSelectTime={onSelectTime}
          selectedTime={selectedTime}
        />
      ),
    },
  ];
  return (
    <>
      <div className="font-medium text-sm text-gray-700 mb-2">
        {t("sessionDate")}
      </div>
      <DateHeaderContainer
        datesList={dates}
        onSelectDay={onSelectDate}
        selectedDate={selectedDate}
      />
      <div className="font-medium text-sm text-gray-700 mt-6 mb-2">
        {t("sessionTime")}
      </div>
      <div className="w-full">
        <TabsComponent tabs={timeTabs} showDropDownOnMobile={false} />
      </div>
    </>
  );
}
